import { useState, startTransition, useEffect } from "react"
import { motion } from "framer-motion"
import styled from "@emotion/styled"

import { useConsole } from "contexts/Console"
import { useDictionary } from "contexts/Dictionary"

import getMediaQuery from "css/breakpoints"
import { fullGrid } from "css/grid"

import Button from "components/button/Button"

import { useRoller } from "./contexts"

const ArrowsContainer = styled.div`
  ${fullGrid}
  z-index: 1;
  pointer-events: none;
  transform: translateY(-50%);
  position: absolute;
  width: 100vw;
  top: 50%;
`

const Marrow = styled(motion.div)`
  justify-self: center;
  grid-row: 1;
  &.previous {
    justify-self: end;
    grid-column: doc-start;
    margin-inline-end: calc(var(--btn-height) / -2 - var(--grid-gap));
  }
  &.next {
    justify-self: start;
    grid-column: main-end;
    margin-inline-start: calc(var(--btn-height) / -2 - var(--grid-gap));
  }

  ${getMediaQuery("m")} {
    &.previous {
      margin-inline-end: calc(var(--btn-height) / -2 - var(--grid-gap) / 2);
    }
    &.next {
      margin-inline-start: calc(var(--btn-height) / -2 - var(--grid-gap) / 2);
    }
  }

  ${getMediaQuery("l")} {
    &.previous,
    &.next {
      justify-self: center;
      margin-inline: unset;
    }
  }

  &.inactive button {
    background: transparent;
  }

  &.inactive svg {
    color: transparent;
  }
`

const ArrowBtn = styled(Button)`
  pointer-events: all;
  backdrop-filter: blur(5px);

  [dir="rtl"] & svg {
    transform: scale(-1);
  }
`

const variants = {
  active: { visibility: "visible" },
  inactive: { transitionEnd: { visibility: "hidden" } },
}

function Arrow({ index }) {
  const console = useConsole()
  const dictionary = useDictionary()

  const { currentIndex } = useRoller()
  const [active, setActive] = useState(currentIndex.get() === index)

  const onClick = () => {
    if (active) return
    currentIndex.set(index)
  }

  function onIndexChange(i) {
    startTransition(() => setActive(i === index))
  }
  useEffect(() => currentIndex.onChange(onIndexChange))

  return (
    <Marrow
      className={`${index === 0 ? "previous" : "next"}${!active ? "" : " inactive"}`}
      variants={variants}
      animate={!active ? "active" : "inactive"}
      initial={!active ? "active" : "inactive"}
      transition={{ type: "tween", ease: "easeOut", duration: 0.3 }}
    >
      <ArrowBtn
        className='icon translucent-light'
        onPress={onClick}
        tabIndex={-1}
        aria_label={index === 0 ? dictionary.previous() : dictionary.next()}
        icon={index === 0 ? "movePrevious" : "moveNext"}
      />
    </Marrow>
  )
}

export default function Arrows() {
  return (
    <ArrowsContainer>
      <Arrow index={0} />
      <Arrow index={1} />
    </ArrowsContainer>
  )
}
